import * as React from 'react';
import styled, { css } from 'styled-components';
import { CalendarView } from '../calendar-types';
import { Typography } from '../../typography';
import { selectThemeSemantics } from '../../../styling';
import { ActionButton } from '../../button';
import { getMonthName } from '@agilepoint/utils-date-time';
import { StackPanel } from '../../stack-panel';

export interface ICalendarMonthNavigatorProps {
    onPreviousMonthClick: (ev: React.MouseEvent) => void;
    onNextMonthClick: (ev: React.MouseEvent) => void;
    previousMonthTitle?: string;
    nextMonthTitle?: string;
    monthsInView: CalendarView[];
    culture?: string;
}

const navButtonStyles = css`
    fill: ${selectThemeSemantics(({ palette }) => palette.black)};
    position: absolute;
    top: 50%;
    cursor: pointer;
`;

const PrevMonthButton = styled(ActionButton).attrs({
    iconName: 'ap-sort-asc-des.solid',
    className: 'ap-calender-previousMonth'
})`
    ${navButtonStyles}
    left: 8px;
    transform: translateY(-50%) rotate(-90deg);
`;

const NextMonthButton = styled(ActionButton).attrs({
    iconName: 'ap-sort-asc-des.solid',
    className: 'ap-calender-nextMonth'
})`
    ${navButtonStyles}
    right: 8px;
    transform: translateY(-50%) rotate(90deg);
`;

const MonthName = styled(Typography.Medium)`
    line-height: 20px;
    text-align: center;
`;

const CalendarMonthNavigatorWrapper = styled.div`
    position: relative;
    width: 100%;
    height: 20px;
`;

export function CalendarMonthNavigator(props: ICalendarMonthNavigatorProps) {
    const { previousMonthTitle = 'Previous Month', nextMonthTitle = 'Next Month', monthsInView, culture } = props;
    return (
        <CalendarMonthNavigatorWrapper>
            <PrevMonthButton role="button" type="button" tabIndex={0} title={previousMonthTitle} onClick={props.onPreviousMonthClick} />
            <StackPanel width="100%" height="100%" orientation="horizontal" justifyContent="space-around">
                {monthsInView.map(({ month }) => <MonthName key={month}>{getMonthName(month, 'long', culture)}</MonthName>)}
            </StackPanel>
            <NextMonthButton role="button" type="button" tabIndex={0} title={nextMonthTitle} onClick={props.onNextMonthClick} />
        </CalendarMonthNavigatorWrapper>
    );
}
